import React from "react"
import {FieldGlistGroupProps} from "../../../../render/glist/glist-group";


export default function FieldRAG_GlistGroupModern(props:FieldGlistGroupProps) {

    const value = props.data.value


    const option = props.field._getOption(value);

    const classes = Classes("icon", "i5-rag", {
        'red': option.value === 0,
        'amber': option.value === 1,
        'green': option.value === 2,
    });

    const groupName = _.get(option, 'label', props.field.noValueOptionLabel);

    return (
        <div className="ui5-chip s26 gray">
            <div className={classes}/>
            <div className="label">{groupName}</div>
        </div>
    )

}
